import config from '@app/config'

import { CULTURE_TO_DOMAINS, type PortalEnvironment } from './constants'

const ensureProtocol = (domain: string) => {
  if (domain.startsWith('http://') || domain.startsWith('https://')) {
    return domain
  }
  return `https://${domain}`
}

const normalizeCulture = (culture: string) => {
  const sanitized = culture.trim().replace(/_/g, '-')
  const parts = sanitized.split('-')
  if (parts.length === 1) {
    return parts[0].toLowerCase()
  }

  const normalizedParts = parts.map((segment, index) => {
    if (index === 0) {
      return segment.toLowerCase()
    }
    if (segment.length === 2) {
      return segment.toUpperCase()
    }
    return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase()
  })

  return normalizedParts.join('-')
}

const lookupDomain = (cultureKey: string, env: PortalEnvironment) => {
  return CULTURE_TO_DOMAINS[env][cultureKey]
}

export const getPortalUrlByCulture = (culture: string | null | undefined) => {
  if (!culture) {
    return undefined
  }

  const normalized = normalizeCulture(culture)
  const env = config.environment as PortalEnvironment
  const fallbacks = [normalized]

  const language = normalized.split('-')[0]
  if (language && language !== normalized) {
    fallbacks.push(language)
  }

  for (const key of fallbacks) {
    const domain = lookupDomain(key, env)
    if (domain) {
      return ensureProtocol(domain)
    }
  }

  return undefined
}
